// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8bb59324","498":"ac028d32"}[chunkId] + ".chunk.js";
};